module.exports = __webpack_public_path__ + "guide-integration02.c62ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/guide-integration02.svg
// module id = ./src/_asset/sources/assets/images/@svg/guide-integration02.svg
// module chunks = main